var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.2003 39.9134C48.907 42.02 45.8669 43.1934 42.7469 43.1667H16.9869C6.13358 42.3934 6.10692 26.6334 16.9869 25.8601H17.0936C9.65361 5.16672 41.0936 -3.07334 44.6936 18.6333C54.747 19.9133 58.827 33.2734 51.2003 39.9134Z",
    fill: "#7E54C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57H37.3821L36.1321 56.5L37.3821 56H48C48.2649 56 48.5 56.2351 48.5 56.5C48.5 56.7649 48.2649 57 48 57ZM36.1056 56.5106L36.108 56.5096L35.5634 57.8994C35.0075 59.3178 33.6019 60.3333 32 60.3333C30.3981 60.3333 28.9925 59.3178 28.4366 57.8994L27.892 56.5096L27.8944 56.5106L28.4401 55.0918C28.821 54.1012 29.6012 53.321 30.5918 52.94L32 52.3984L33.4082 52.94C34.3988 53.321 35.179 54.1012 35.5599 55.0918L36.1056 56.5106ZM26.6179 56L27.8679 56.5L26.6179 57H16C15.7351 57 15.5 56.7649 15.5 56.5C15.5 56.2351 15.7351 56 16 56H26.6179ZM32.5 51.1179L32 52.3679L31.5 51.1179V44.6667H32.5V51.1179Z",
    stroke: "#7E54C5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDashboard);
export default __webpack_public_path__ + "static/media/cloud-dashboard.5215eb60bba595e8e7f726caf65df21f.svg";
export { ForwardRef as ReactComponent };